var LANG = {
	"clientConnectionError" : 'Ihre Anmeldedaten sind falsch',
	"optionsTri" : {
		"top" : 'Beliebtheit',
		"moyavis" : 'Kundenbewertungen',
		"nomaz" : 'Name A->Z',
		"nomza" : 'Name Z->A',
		"prixasc" : 'Niedrigster Preis',
		"prixdesc" : 'Höchster Preis',
		"rank" : 'Relevanz',
		"pctreduc" : '% Rabatt',
		"datedesc" : 'Neuheiten',
		"dateasc" : 'Älteste',
		"qteasc" : 'Stock -',
		"qtedesc" : 'Stock +',
		"margeasc" : '% Marge -',
		"margedesc" : '% Marge +'
	},
	"client_existe" : 'Es existiert bereits ein Konto mit dieser E-Mail.',
	"client_existebis" : 'Ein Konto mit dieser E-Mail-Adresse existiert bereits.<br />Bitte geben Sie Ihr Passwort ein oder klicken Sie <a href="/clients/?pg=lost">hier</a>, wenn Sie es vergessen haben.',
	"clientInvalidForm" : 'Formular unvollständig',
	"form" : {
		"error" : {
			"required" : 'Das Feld ist obligatorisch',
			"array" : 'Dieses Feld muss ein Array sein',
			"civilite" : 'Die gewählte Höflichkeit ist ungültig',
			"codepostal_5_chiffres" : 'Die Postleitzahl muss 5 Ziffern enthalten',
			"codepostal" : 'Die Postleitzahl fehlt oder ist ungültig.',
			"egal" : 'Dieses Feld wurde nicht korrekt bestätigt',
			"email" : 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
			"emailDomain" : 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
			"file" : 'Die Datei ist ungültig',
			"int" : 'Dieses Feld muss eine Ganzzahl sein',
			"length_from_to" : 'Dieses Feld muss {0} bis {1} Zeichen enthalten',
			"length_from" : 'Dieses Feld muss mindestens {0} Zeichen enthalten',
			"length_to" : 'Dieses Feld muss maximal {0} Zeichen enthalten',
			"password" : 'Das Passwort muss zwischen {0} und {1} Zeichen enthalten',
			"prenomnom" : 'Bitte geben Sie Ihren Vornamen und Ihren Nachnamen durch ein Leerzeichen getrennt ein',
			"pays" : 'Das Feld ist obligatorisch',
			"telfixe" : 'Die Heimtelefonnummer ist leer oder ungültig.',
			"telmobile" : 'Die Handynummer fehlt oder ist ungültig.'
		}
	},
	"parentT" : {
		"p1" : 'Tochter - Sohn',
		"p2" : 'Enkelin - Enkel',
		"p3" : 'Nichte - Neffe',
		"p4" : 'Schwester - Bruder',
		"p5" : 'Patenkind',
		"p6" : 'Andere'
	},
	"filtres" : {
		"typeNouveaute" : 'Neuheit',
		"typeRetourStock" : 'Wieder auf Lager',
		"typePromotion" : 'Sonderangebot',
		"typeBonneAffaire" : 'Schnäppchen',
		"typeDestockage" : 'Lagerräumung',
		"typeSolde" : 'Verkauf',
		"typeObsolete" : 'Veraltet',
		"typeOffreDuMoment" : 'Aktuelles Angebot',
		"typeMadeInFrance" : 'Made in France',
		"siteRef" : 'Thema',
		"category" : 'Kategorie',
		"type" : 'Art',
		"offer" : 'Angebot',
		"price" : 'Preis',
		"promotion" : 'Beförderung',
		"size" : 'Größe',
		"rangePalier" : 'von {0} bis {1}{2}',
		"rangeMax" : 'mehr als {0}{1}',
		"prixPalier" : 'von {0} bis {1}€',
		"prixMax" : 'mehr als {0}€',
		"promoPalier" : 'von {0} bis {1}%',
		"promoMax" : 'mehr als {0}%'
	},
	"defaultFiltresAttribut" : {
		"atr0" : 'Alle Wahlmöglichkeiten',
		"atr3" : 'Alle Maßstäbe',
		"atr152" : 'Alle Größen',
		"atr542" : 'Alle Themen',
		"atr572" : 'Alle Künstler',
		"atr168" : 'Alle Formate',
		"atr573" : 'Alle Formen',
		"atr543" : 'Alle Figuren'
	},
	"trancheAge" : {
		"palier" : 'von %1$s %2$s bis %3$s %4$s',
		"max" : 'Ab %1$s %2$s'
	},
	"civilite" : {
		"M" : 'Herr',
		"Mme" : 'Frau',
		"Mlle" : 'Fräulein'
	},
	"panier" : {
		"articles" : '{0}',
		"articles/zero" : '0',
		"articles_euros" : '{0}',
		"articles_euros/zero" : '0'
	},
	"panierAriane" : {
		"state1" : 'Warenkorb',
		"state2" : 'Adresse und Lieferung',
		"state3" : 'Bezahlung'
	},
	"clientAriane" : {
		"coordonnees" : 'Ihre Kontaktdaten',
		"mescoordonnees" : 'Meine Kontaktdaten',
		"adressemail" : 'Änderung der E-Mail-Adresse',
		"motdepasse" : 'Mein Passwort ändern',
		"account" : 'Mein Kundenkonto',
		"sav" : 'An den Kundendienst schreiben',
		"commandes" : 'Meine Bestellungen ansehen',
		"porte_monnaie" : 'Meine Geldbörse',
		"sauvegarde" : 'Meine gespeicherten Warenkörbe',
		"wishlist" : 'Meine Wunschlisten',
		"wishlist_new" : 'Ich erstelle meinen Wunschzettel',
		"wishlist_detail" : 'Meine Liste',
		"wishlist_share" : 'Ich teile meine Liste',
		"wishlist_added" : 'zu meiner Wunschliste hinzugefügt',
		"suivi" : 'Meine Bestellungen nachverfolgen',
		"myavis" : 'Meine Bewertungen',
		"setavis" : 'Geben Sie Ihre Bewertung ab',
		"cfwelcome" : 'Mein Treue Club-Bereich',
		"cfinformations" : 'Meine Informationen',
		"cfprogramme" : 'Das Treue Club-Programm',
		"cfcheques" : 'Meine Treue Club-Schecks',
		"newsletters" : 'Newsletter'
	},
	"alertQuantiteError" : 'Ungültige menge',
	"alertMaxQty" : 'Sie haben die einzigen [stock] product(s) produkte in Ihrem Warenkorb.',
	"alertStockInPanier" : 'Wir haben nur noch {1} Exemplar(e) auf Lager. Sie haben {0} Exemplare von diesem Produkt in Ihrem Warenkorb.',
	"alertStockInPanier/one" : 'Wir haben nur noch {1} Exemplar(e) auf Lager. Sie haben 1 Exemplar dieses Produkts in Ihrem Warenkorb.',
	"alertStockInPanier/zero" : 'Wir haben nur noch {1} Exemplar(e) auf Lager.',
	"jsMiseEnPanier" : 'In den Warenkorb',
	"livraison_indisponible" : 'Versandart nicht verfügbar<br />(übergewichtige Bestellung)',
	"etape2_relais_portable_title" : 'Ihre Handynummer ist erforderlich',
	"etape2_relais_portable_text" : 'So kann der Spediteur Sie benachrichtigen, wenn Ihr/ Paket eintrifft.',
	"etape2_relais_no_result" : 'Leider ist keine Abholstelle in der Nähe verfügbar. Sie können jedoch eine andere Abholstelle versuchen.',
	"estimated_delivery_text_root" : 'Geplante Lieferung',
	"estimated_delivery_text_root_partial" : 'Erwartete Teillieferung',
	"estimated_delivery_text_root_christmas" : 'Garantierte Lieferung zur Weihnachtszeit',
	"estimated_delivery_text" : 'Lieferung zwischen dem {0} und dem {1}',
	"estimated_delivery_text_single" : 'Lieferung geplant am {0}',
	"estimated_delivery_array" : 'am {0} und am {1}',
	"estimated_delivery_array_single" : 'am {0}',
	"product_estimated_delivery_text" : 'Geliefert zwischen dem {0} und dem {1}',
	"product_estimated_delivery_text_single" : 'Ausgeliefert am {0}',
	"product_estimated_delivery_text_chrono" : '... oder wählen Sie den Expressversand für eine Lieferung am {0}',
	"delivered_home" : 'Nach Hause geliefert',
	"delivered" : 'Geliefert',
	"delivered_estimated" : 'Geliefert zwischen',
	"delivered_in_two_weeks" : 'Lieferung innerhalb von 2 Wochen',
	"type_delivery_text" : {
		"code55" : 'Abholung am Übergabeautomaten',
		"code3" : 'Expressversand zu einem Abholpunkt',
		"code61" : 'Lieferung zu Ihnen nach Hause',
		"code60" : 'Lieferung zu Ihnen nach Hause (mit Unterschrift)',
		"code2" : 'Express Lieferung nach Hause',
		"code8" : 'Rücknahme in unserem Lager in Frankreich',
		"code5" : 'Expressversand an einem Abholpunkt',
		"code4" : 'Express Lieferung nach Hause',
		"code34" : '',
		"code69" : 'Lieferung in einer Post',
		"code68" : 'Lieferung an einem Abholpunkt',
		"code67" : '',
		"code66" : '',
		"code63" : 'Lieferung an einem Abholpunkt',
		"code62" : 'Lieferung in einer Post',
		"code35" : '',
		"code50" : 'Lieferung an einem Abholpunkt',
		"code20" : 'Lieferung zu Ihnen nach Hause',
		"codeautre" : 'Lieferung zu Ihnen nach Hause'
	},
	"age" : {
		"month" : 'Monate',
		"month/one" : 'Monat',
		"year" : 'Jahre',
		"year/one" : 'Jahr'
	},
	"product" : {
		"recommandedAge" : 'Empfohlen von {0} {1}',
		"recommandedAge/zero" : 'Von Geburt an empfohlen',
		"recommandedAgeFeatureFromTo" : 'Von {0} {1} bis {2} {3}',
		"recommandedAgeFeatureFrom" : 'Von {0} Jahr',
		"recommandedAgeFeatureFrom/one" : 'Von {0} Jahr',
		"ratings" : '{0} Bewertungen',
		"ratings/one" : '{0} Bewertungen',
		"share" : 'Teilen'
	},
	"devise" : {
		"signe" : '€',
		"prix" : '{0}<sup>€{1}</sup>',
		"prixTexte" : '{0}&nbsp;EUR'
	},
	"ariane" : {
		"accueil" : 'Startseite',
		"blog" : 'Blog',
		"byArtist" : 'von Künstlern',
		"byTheme" : 'by themes'
	},
	"productType" : 'Puzzles',
	"codePromo" : {
		"code0" : 'Ihr Code wurde berücksichtigt.',
		"code1" : 'Ihr Rabatt wurde für berechtigte Produkte berücksichtigt.',
		"code2" : 'Leider ist dieser Code abgelaufen oder unbekannt.',
		"code3" : 'Um Ihr Angebot in Anspruch zu nehmen, identifizieren Sie sich bitte.',
		"code4" : 'Es tut uns leid, aber Ihre Produktauswahl entspricht nicht den Kriterien für diesen Angebotscode..',
		"code5" : 'Es tut uns leid, aber dieser Angebotscode gilt nicht für Produkte, die bereits ermäßigt sind..',
		"code6" : '',
		"code7" : 'Es tut uns leid, aber das angebotene Produkt, das von Ihrem Gutscheincode betroffen ist, ist nicht mehr auf Lager..',
		"code9" : 'Ihr Code wurde berücksichtigt, aber die von Ihrem Angebotscode betroffenen Produkte sind nicht mehr auf Lager. Die Angebotsaktion wurde jedoch auf Ihren Warenkorb angewendet.',
		"code8" : 'Ihr Code wurde berücksichtigt, aber einige der angebotenen Produkte, die von Ihrem Promo-Code betroffen sind, sind nicht mehr auf Lager. Die anderen wurden in Ihren Warenkorb gelegt.',
		"code10" : 'Es tut uns leid, aber für diesen Code ist eine bestimmte menge von Bestellungen erforderlich.'
	},
	"caddieOption" : {

	},
	"panierOffreSpeciale" : 'GESCHENK : ',
	"panierFraisTraitement" : 'Bearbeitungsgebühren',
	"panierCgv" : 'Sie müssen die allgemeinen Geschäftsbedingungen lesen und akzeptieren',
	"prixDevise" : '{0}&nbsp;€',
	"prixDeviseTxt" : '{0} EUR',
	"gratuit" : 'Kostenlos',
	"formatDateStrtotime" : {
		"date" : 'd/m/Y',
		"interval" : '%d Tage'
	},
	"formatDate" : {
		"date" : '%x',
		"dateComplete" : '%e %B %Y',
		"jourMois" : '%e %B',
		"dateHeure" : '%d/%m/%Y %R',
		"dateTime" : '%d/%m/%Y %T',
		"dateMoisHeureMinute" : '%d/%m %R',
		"dateJourHeure" : '%A %d/%m/%Y %R',
		"dateJour" : '%A %d/%m/%Y'
	},
	"js_filtre_prix" : 'von $1 € bis$2 €',
	"generique_age_126" : '0 bis3 monates',
	"generique_age_127" : '0 bis6 monates',
	"generique_age_137" : '0 bis1 jahr',
	"generique_age_144" : '0 bis2 jahre',
	"generique_age_145" : '0 bis3 jahre',
	"generique_age_146" : '0 bis4 jahre',
	"generique_age_147" : '0 bis5 jahre',
	"generique_age_148" : '0 bis6 jahre',
	"generique_age_149" : '0 bis7 jahre',
	"generique_age_154" : '0 bis8 jahre',
	"generique_age_155" : '0 bis9 jahre',
	"generique_age_156" : '0 bis10 jahre',
	"generique_age_157" : '0 bis11 jahre',
	"generique_age_158" : '0 bis12 jahre',
	"generique_age_165" : '0 bis13 jahre',
	"generique_age_166" : '0 bis14 jahre',
	"generique_age_167" : '0 bis15 Jahre und älter',
	"prix_devise" : '{0}&nbsp;€',
	"prix_devise_txt" : '{0} EUR',
	"produit_trop_lourd" : '<font color="red">Leider können wir dieses Produkt nicht liefern, es wiegt <b>%s kg</b> und überschreitet die zulässige Grenze von <b>%s kg</b>. Bitte kontaktieren Sie unseren Kundenservice.</font>',
	"ht" : 'ohne MwSt.',
	"ttc" : 'inkl. MwSt.',
	"marque" : 'Marken',
	"licence" : 'Lizenzen',
	"civilite_1" : 'Herr',
	"civilite_2" : 'Frau',
	"civilite_3" : 'Fräulein',
	"client_invalid_nd" : 'Ihre Dossiernummer ist ungültig.',
	"client_connection_error" : 'Ihre Anmeldedaten sind falsch',
	"client_code_porte" : 'Türcode',
	"client_code_porte2" : 'Gebäudecode',
	"client_interphone" : 'Gegensprechanlage',
	"client_invalid_cp_5_chiffre" : 'Die Postleitzahl muss 5-stellig sein',
	"client_invalid_mail" : 'Stellen Sie sicher, dass Sie eine gültige E-Mail-Adresse eingeben.',
	"client_invalid_pwd" : 'Ihr Passwort muss aus mindestens 6 Zeichen bestehen.',
	"client_invalid_pwd2" : 'Das Passwort ist nicht bestätigt.',
	"client_invalid_telfixe" : 'Die Festnetznummer ist leer oder ungültig.',
	"client_invalid_nom" : 'Bitte geben Sie Ihre(n) Vorname(n) und Ihren Nachnamen mit einem Leerzeichen zwischen den einzelnen Wörtern ein.',
	"client_invalid_prenom" : 'Der Vorname ist leer oder ungültig.',
	"client_invalid_adresse1" : 'Adresse nicht erkannt oder unvollständig.',
	"client_invalid_cp" : 'Fehlende oder nicht erkannte Postleitzahl.',
	"client_invalid_ville" : 'Die Stadt ist leer oder ungültig.',
	"client_invalid_pays" : 'Das Land ist leer oder ungültig.',
	"client_modifie_pays" : 'Das Land wurde geändert.',
	"client_invalid_telG" : 'Fehlende oder falsche Rufnummer.',
	"client_invalid_telport" : 'Die Handynummer ist leer oder ungültig.',
	"client_invalid_fax" : 'Die Faxnummer ist leer oder ungültig.',
	"client_invalid_ddn" : 'Es scheint, dass dieses Geburtsdatum nicht den Regeln entspricht oder unwahrscheinlich ist.',
	"client_invalid_password" : 'Das Passwort ist leer, ungültig oder stimmt nicht überein.',
	"client_invalid_modeliv" : 'Die gewählte Lieferart ist nicht verfügbar',
	"client_modification_mail_existe" : 'Ein anderes Kundenkonto mit dieser E-Mail existiert bereits. Sie können versuchen, sich abzumelden und dann mit dieser E-Mail-Adresse wieder anzumelden.',
	"client_erreur_insertion" : 'Ein vorübergehendes technisches Problem hat einen Fehler bei Ihrer Registrierung verursacht, bitte versuchen Sie es in einigen Minuten erneut.',
	"client_erreur_update_adresse" : 'Ein vorübergehendes technisches Problem hat einen Fehler verursacht, bitte versuchen Sie es in einigen Minuten erneut',
	"client_modification_commande" : 'Änderung der Bestellung',
	"client_modification_adresse" : 'Eine Adresse ändern',
	"client_ajout_adresse" : 'Eine Lieferadresse hinzufügen',
	"client_adresse_facturation" : 'Rechnungsadresse',
	"client_adresse_livraison" : 'Lieferadresse',
	"client_adresse_livraison_principale" : 'Hauptlieferadresse',
	"client_modification_adresse_facturation" : 'Ihre Rechnungsadresse ändern',
	"client_modification_adresse_livraison" : 'Ihre Lieferadresse ändern',
	"client_confirm_suppression_adresse" : 'Diese Adresse löschen?',
	"client_erreur_generique" : 'Unser Server ist zur Zeit nicht verfügbar. Bitte verbinden Sie sich später mit Ihrem Kundenbereich, um Ihre Bestellung wiederzufinden.',
	"client_note_error" : 'Sie müssen eine Note auswählen.',
	"client_avis_error" : 'Sie müssen einen Kommentar schreiben.',
	"client_pseudoregex_error" : 'Der Nickname muss mindestens 5 Zeichen enthalten, nur Buchstaben und Zahlen.',
	"client_pseudodeja_error" : 'Dieser Nickname ist nicht verfügbar.',
	"client_pseudo_error" : 'Der Nickname ist leer oder ungültig.',
	"client_corse_chronopost" : 'Die Chronopost-Zustellung ist für diese Adresse nicht verfügbar',
	"client_sav_message_error" : 'Ihre Nachricht ist leer oder ungültig.',
	"client_sav_upload_error" : 'Fehler beim Herunterladen der Dateien. Bitte prüfen Sie, ob Größe und Format der Dateien unterstützt werden.',
	"client_sav_commande_error" : 'Bitte wählen Sie eine Bestellung aus.',
	"client_sav_categorie_invalid" : 'Bitte wählen Sie eine Kategorie aus.',
	"client_livraison_gratuite" : 'Kostenlos mit Ihrem Gutscheincode',
	"client_invalid_pack" : 'Dieses Paket ist nicht verfügbar',
	"client_invalid_form" : 'Formular unvollständig',
	"client_password" : 'Passwort',
	"client_invalid_formulaire" : 'Formular unvollständig oder Daten ungültig. Bitte korrigieren bzw. vervollständigen Sie die erforderlichen Informationen in den rot markierten, mit Warnhinweisen versehenen Feldern',
	"avisUtile" : '{0} Personen fanden das nützlich',
	"avisUtile/one" : '1 Person fand das nützlich',
	"avisUtile/zero" : '',
	"wish_in" : 'Dieses Produkt ist auf Ihrer Favoritenliste',
	"wish_open" : 'Meine Favoritenliste ansehen',
	"wish_del" : 'Dieses Produkt aus meiner Favoritenliste entfernen',
	"wish_add" : 'Zu meiner Favoritenliste hinzufügen',
	"comgroup_total_maxi" : 'Ihre Bestellung überschreitet den für Ihr Konto zulässigen Höchstbetrag, der sich beläuft auf ',
	"comgroup_interdit" : 'Die folgenden Artikel sind nicht Teil Ihres Angebots:',
	"comgroup_interdit2" : 'Sie müssen sie aus dem Warenkorb entfernen, um eine Bestellung aufzugeben.',
	"comgroup_date" : 'Ihr Konto ist derzeit nicht aktiv: Sie können keine Bestellung aufgeben.',
	"comgroup_produit" : 'Dieses Produkt ist nicht Teil Ihres Angebots',
	"code_promo_negatif" : 'Es tut uns leid, aber diese Produkte können nicht von diesem Sonderangebot profitieren.',
	"pack_1" : 'Klassische Garantie',
	"pack_2" : 'SMS-Tracking-Garantie',
	"pack_4" : 'Sorgenfrei-Garantie + SMS tracking',
	"pack_5" : 'Sorgenfrei-Garantie',
	"pack_3" : 'Garantie Privileg',
	"js_instructions" : 'Lieferanweisungen',
	"js_portable_destinataire" : 'Mobiltelefon des Empfängers',
	"pack_1_desc" : 'Beschreibung des kostenlosen Pakets',
	"pack_2_desc" : 'Beschreibung des SMS Tracking Pakets',
	"pack_4_desc" : 'SBeschreibung des Rundum-Sorglos-Pakets + SMS-Tracking',
	"pack_3_desc" : 'Beschreibung des Sorgenfrei-Pakets',
	"pack_5_desc" : 'Beschreibung des Rundum-Sorglos-Pakets',
	"sms_envoi_vers" : 'SMS-Nachrichten werden gesendet an',
	"expediee" : 'Bestellung versandt',
	"enPreparation" : 'Bestellung in Bearbeitung',
	"enAttente" : 'Bestellung wartet auf Bearbeitung',
	"enTraitement" : 'In Bearbeitung',
	"nonPayee" : 'Warten auf Ihre Zahlung',
	"avoirDispo" : 'Das PDF-Guthaben herunterladen, das generiert wurde am {0}',
	"factureDispo" : 'Download der PDF-Rechnung',
	"devisDispo" : 'Download des PDF-Kostenvoranschlags',
	"marketplace" : 'Marketplace-Bestellung',
	"alert_problemStock" : 'Mehrere Produkte in Ihrem Warenkorb sind nicht mehr in der von Ihnen gewünschten menge verfügbar. Sie müssen sie ändern, um fortzufahren.',
	"alert_problemStock/one" : 'Das unten gemeldete Produkt ist nicht mehr in der von Ihnen gewünschten menge verfügbar. Sie müssen es ändern, um fortzufahren.',
	"alert_quantite_error" : 'Ungültige menge',
	"alert_problemStockButton" : 'Update-Wagen',
	"alert_problemStockButtonFromEtape3" : 'Aktualisieren und zurück zum Warenkorb',
	"alert_maxqte" : 'Sie haben die {0} letzten Exemplare in Ihrem Warenkorb.',
	"alert_maxqte/one" : 'Sie haben das letzte Exemplar in Ihrem Warenkorb.',
	"js_stock_vide" : 'Wir haben nur noch [stock] Exemplar(e) auf Lager.',
	"alert_stock_in_panier" : 'Wir haben nur noch {0} Exemplar(e) auf Lager. Sie haben {1} Exemplar(e) dieses Produkts in Ihrem Warenkorb',
	"js_miseenpanier" : 'Hinzugefügt',
	"alert_errorSaveAsCommande" : 'Es gab ein Problem bei der Registrierung Ihres Warenkorbs. Unser Team wurde sofort informiert, wir laden Sie ein, es später noch einmal zu versuchen.',
	"nb_stock_full" : 'Vorrätig',
	"nb_stock_low" : 'Nur noch {0} Artikel auf Lager',
	"nb_stock_low/one" : 'Nur noch 1 Artikel auf Lager',
	"nb_stock_low/zero" : 'Artikel nicht verfügbar',
	"exemplaires_en_stock" : '{0} Exemplare auf Lager',
	"exemplaires_en_stock/one" : '1 Exemplar auf Lager',
	"exemplaires_en_stock2" : '{0} Produkte',
	"exemplaires_en_stock2/one" : '1 Produkt',
	"moins_de_exemplaires_en_stock" : 'Weniger als %s Exemplare auf Lager',
	"plus_de_exemplaires_en_stock" : 'Mehr als %s Exemplare auf Lager',
	"pagination_produits" : 'Produkte',
	"pagination_produits/one" : 'Produkt',
	"pagination_souscats" : 'Kategorien',
	"pagination_souscats/one" : 'Kategorie',
	"pagination_elts" : 'Elemente',
	"pagination_elts/one" : 'Element',
	"pagination_aucun_element" : 'Es tut uns leid, aber kein Artikel entspricht Ihrer Auswahl.',
	"wishlist_aucun_element" : 'Sie haben keine Liste mit Lieblingsprodukten',
	"search_aucun_element" : 'Es scheinen keine Produkte zu Ihrer Suche zu passen.',
	"search_aucun_element_bis" : 'Wir bieten Ihnen unsere Bestseller :',
	"option_tri_top" : 'Beliebtheit',
	"option_tri_moyavis" : 'Kundenbewertungen',
	"option_tri_nomaz" : 'Name A->Z',
	"option_tri_nomza" : 'Name Z->A',
	"option_tri_prixasc" : 'Niedrigster Preis',
	"option_tri_prixdesc" : 'Höchster Preis',
	"option_tri_rank" : 'Relevanz',
	"option_tri_pctreduc" : 'Rabatt %',
	"option_tri_datedesc" : 'Neuheiten',
	"option_tri_dateasc" : 'Älteste',
	"option_tri_qteasc" : 'Stock -',
	"option_tri_qtedesc" : 'Stock +',
	"option_tri_margeasc" : '% Marge -',
	"option_tri_margedesc" : '% Marge +',
	"type" : {
		"nouveaute" : 'Neuheit',
		"promotion" : 'Verkauf',
		"bonneAffaire" : 'Schnäppchen',
		"destockage" : 'Lagerräumung',
		"retourStock" : 'Wieder auf Lager'
	},
	"search_yoursearch" : 'Die Ergebnisse für',
	"search_didyoumean" : 'Meinten Sie eher {0} ?',
	"search_partiel" : 'Diese Produkte entsprechen einigen Ihrer Suchbegriffe',
	"search_partiel_like" : 'Diese Ergebnisse können einigen Ihrer Suchbegriffe entsprechen :',
	"search_default" : 'Stichwortsuche',
	"panier_offre_speciale" : 'GESCHENK',
	"panier_offre_speciale_change" : 'Das Angebot ändern.',
	"panier_frais_traitement" : 'Bearbeitungsgebühren',
	"panier_cgv" : 'Sie müssen die allgemeinen Geschäftsbedingungen lesen und akzeptieren',
	"panier_cb" : 'CB-Zahlung',
	"panier_cb_montant" : 'Betrag Ihrer Bestellung: ',
	"panier_cb_texte" : 'Anmeldung zur sicheren Bezahlung<br/>Danke fürs Warten...',
	"attribut_listCategories" : 'Kategorie',
	"attribut_filtres" : 'Ihre Suche eingrenzen',
	"attribut_all" : 'Kein Filter',
	"filtre_age" : 'Produktsuche nach Altersgruppe',
	"tranche_ageMM" : 'from %1$s to %2$s month old',
	"tranche_ageMY" : 'from %1$s mois to %2$s years old',
	"tranche_ageYY" : 'from %1$s to %2$s years old',
	"tranche_ageYPlus" : 'for more than %1$s years old',
	"mois" : 'month',
	"ans" : 'years',
	"ans/one" : 'year',
	"paiement" : {
		"CG" : 'Überweisung',
		"VIR" : 'Überweisung',
		"CHQ" : 'Scheck',
		"MDC" : 'Postanweisung',
		"MDA" : 'Zahlung durch Behördenkasse',
		"CHQ3X" : 'Scheck 3X',
		"CHQ2X" : 'Scheck 2X',
		"CB" : 'Bankkarte',
		"KADEOS" : 'Geschenkgutschein KADEOS',
		"CADHOC" : 'Geschenkgutschein CADHOC',
		"CADO" : 'Geschenkgutschein CADO',
		"TIRGROUPE" : 'Geschenkgutschein TIRGROUPE',
		"CHQLUDENDO" : 'Chèque salarié Ludendo',
		"PP" : 'PayPal',
		"EXT" : 'Externe',
		"RP" : 'ReceiveAndPay EN UNE FOIS par carte bancaire',
		"RP3X" : 'ReceiveAndPay EN PLUSIEURS FOIS, avec l\'option de crédit',
		"PM" : 'Geldbörse'
	},
	"name_paiement" : {
		"9" : 'karte',
		"10" : 'paypal',
		"1" : 'scheck',
		"4" : 'scheck2x',
		"14" : 'scheck3x',
		"60" : 'scheckkdo',
		"2" : 'überweisung',
		"3" : 'mandatcash',
		"6" : 'mandatadmin'
	},
	"text_paiement" : {
		"9" : 'karte',
		"10" : 'Paypal',
		"1" : 'Scheck',
		"4" : 'Scheck 2x',
		"14" : 'Scheck 3x',
		"60" : 'Geschenkgutschein',
		"2" : 'überweisung',
		"3" : 'Mandat',
		"6" : 'Zahlung durch Behördenkasse'
	},
	"label_paiement" : {
		"9" : 'Karte',
		"10" : 'Paypal',
		"1" : 'Scheck',
		"4" : 'Scheck 2x',
		"14" : 'Scheck 3x',
		"60" : 'Geschenkgutschein',
		"2" : 'Überweisung',
		"3" : 'Mandat Cash',
		"6" : 'Zahlung durch Behördenkasse'
	},
	"description_paiement" : {
		"9" : '',
		"10" : '',
		"1" : 'Ihre Schecks müssen auf eine in Frankreich ansässige Bank gezogen sein. Sie müssen ausgestellt werden auf Puzzle Boulevard. <br > Die Bestätigung Ihrer Bestellung und des Versands erfolgt nach Eingang Ihrer Zahlung.',
		"4" : 'Ihre Schecks müssen auf eine in Frankreich ansässige Bank gezogen sein. Sie müssen ausgestellt werden auf Puzzle Boulevard. <br > Die Bestätigung Ihrer Bestellung und des Versands erfolgt nach Eingang Ihrer Zahlung.',
		"14" : 'Ihre Schecks müssen auf eine in Frankreich ansässige Bank gezogen sein. Sie müssen ausgestellt werden auf Puzzle Boulevard. <br > Die Bestätigung Ihrer Bestellung und des Versands erfolgt nach Eingang Ihrer Zahlung.',
		"60" : '* Wir akzeptieren keine Geschenkkarten, Kadeos Culture-Gutscheine.<br>Der Restbetrag ist per Scheck zu zahlen, zahlbar an Avenue des jeux.<br>Die Bestätigung und der Versand erfolgen nach Eingang Ihrer Zahlung.',
		"2" : 'Kauf per Überweisung. Sobald wir Ihre Zahlung erhalten haben, wird Ihre Bestellung bestätigt und versendet. Die Informationen zur Überweisung werden per E-Mail gesendet.',
		"3" : 'Ihre Bestellung wird bestätigt und versendet, sobald der Rechnungsbetrag bei uns eingegangen ist.',
		"6" : 'Reserviert für Verwaltungen. Ihre Bestellung wird nach Erhalt des Nachweises der Zahlung durch die Behördenkasse versandt.'
	},
	"cheque_cadeau" : {
		"61" : 'Cadhoc',
		"60" : 'Kadeos *',
		"62" : 'Tir Groupé',
		"63" : 'CA DO',
		"64" : 'Chèque Salarié Ludendo'
	},
	"modep_RP_descriptif" : 'Vous commandez aujourd\'hui et vous n\'êtes débité qu\'APRES avoir reçu et vérifié votre commande, en une fois par carte bancaire (compatible VISA, CB et Mastercard). ReceiveAndPay est un service FIA-NET 100 % sécurisé, et totalement gratuit pour vous.',
	"modep_RP3X_descriptif" : 'Vous commandez aujourd\'hui et vous n\'êtes débité en plusieurs fois qu\'APRES avoir reçu et vérifié votre commande. Ce paiement nécessite l\'ouverture d\'une réserve de crédit auprès de notre partenaire Sofinco. Celle-ci se fait très simplement en ligne après le choix de votre barème et une réponse de principe en temps réel. ReceiveAndPay est un service FIA-NET 100 % sécurisé et totalement gratuit pour vous.',
	"etape4_choix_chqkdo" : 'Sie müssen die Art des Geschenkgutscheins auswählen',
	"etape4_montant_chqkdo" : 'Sie müssen den Gesamtbetrag des Gutscheins bzw. der Gutscheine angeben',
	"etape4_montant_chqkdo999" : 'Sie müssen einen Gesamtbetrag unter 999 EUR angeben',
	"etape4_err_montant_chqkdo" : 'Der Gesamtbetrag des Geschenkgutscheins bzw. der Geschenkgutscheine ist falsch',
	"blogCategorie" : {
		"c1" : 'Nos tutos & DIY',
		"c2" : 'Les actualités du jouet',
		"c3" : 'Nos tests produits',
		"c4" : 'Notre actu',
		"c5" : 'Les fiches conseils',
		"c6" : 'Les guides d\'achat',
		"c7" : 'Les conseils et astuces',
		"c8" : 'Les actualités du moment'
	},
	"facture_titre" : 'Rechnung {0} vom {1}',
	"devis_titre" : 'Angebot {0} vom {1}',
	"facture_refclient" : 'Kundennummer',
	"facture_adrf" : 'Rechnungsadresse',
	"facture_adrl" : 'Lieferadresse',
	"facture_nom" : 'Vorname Nachname',
	"facture_soc" : 'Unternehmen',
	"facture_adr" : 'Adresse',
	"facture_tel" : 'Telefon',
	"facture_cp" : 'PLZ',
	"facture_ville" : 'Stadt',
	"facture_pays" : 'Land',
	"facture_detail" : 'Details zur Bestellung',
	"facture_ref" : 'Produktnummer',
	"facture_des" : 'Bezeichnung',
	"facture_qte" : 'menge',
	"facture_pu" : 'Einzelpreis o. MwSt.',
	"facture_tva" : 'MwSt.',
	"facture_px" : 'Preis',
	"facture_fp" : 'Versandkosten',
	"facture_ft" : 'Bearbeitungsgebühren',
	"facture_remise" : 'Rabatt',
	"facture_to" : 'Gesamt',
	"facture_donttva" : 'davon MwSt. {0} %',
	"facture_reglement" : 'Datum der Zahlung',
	"facture_modep" : 'Art der Bezahlung',
	"log_client_produits" : 'Gesehene Produkte',
	"no_article" : '0',
	"x_article" : '%d',
	"x_articles" : '%d',
	"x_article_euros" : '%d',
	"x_articles_euros" : '%d',
	"ariane_accueil" : 'Startseite',
	"ariane_blog" : 'Blog',
	"recrut_invalidForm" : 'Fehler: Sie müssen einen Lebenslauf, einen Motivationsbrief und Ihre E-Mail-Adresse laden',
	"recrut_problemeTechnique" : 'Fehler: Technisches ProblemFehler: Technisches Problem',
	"recrut_invalidCaptcha" : 'Fehler: Der zweistellige Code stimmt nicht überein.',
	"recrut_mailOK" : 'Vielen Dank für Ihre Bewerbung. Wir werden uns in Kürze mit Ihnen in Verbindung setzen.',
	"pp_sauve_panier" : 'Bitte beachten: Benutzerdefinierte Puzzles werden nicht gespeichert!',
	"pp_js_maxfiles" : 'Sie können nicht mehr als 6 Bilder hochladen !',
	"pp_js_upload1" : 'Klicken Sie auf die Schaltfläche „Durchsuchen” und wählen Sie Ihr Foto aus (JPG-Format, max. 20 MB).',
	"pp_js_upload2" : 'Der Upload Ihres Fotos wird automatisch gestartet.',
	"pp_js_upload_bt" : 'Wählen Sie ein Bild',
	"pp_js_upload_start" : 'Download läuft...',
	"pp_js_upload_cancel" : 'Abbrechen',
	"pp_js_prepa" : 'Vorbereitung des Fotos',
	"pp_js_errformat" : 'Ihr Bild ist nicht im JPG-Format',
	"pp_js_postal_titre" : 'Um ein personalisiertes Puzzle von einem Papierabzug zu bestellen',
	"pp_js_postal_1" : 'Wählen Sie Fotos mit einer maximalen Größe von 20x30 cm und einer Mindestgröße von 10x13 cm.',
	"pp_js_postal_2" : 'Schicken Sie uns niemals Negative oder Dias. Im Falle eines Verlustes sind sie unersetzlich. Das Foto, das Sie uns schicken, wird durch einen Scanner geschickt und auf die für das Puzzle passenden Maße zugeschnitten. Wenn das Foto eines größeren Zuschnitts bedarf, werden wir Sie kontaktieren, um Ihnen einen Vorschlag zu unterbreiten.',
	"pp_js_postal_3" : 'Um zu bestellen, wählen Sie die menge an Exemplaren des Puzzles, die von Ihrem Foto gemacht werden sollen, kreuzen Sie das Kästchen "Ich bezahle meine Bestellung per Scheck..." an und klicken Sie auf die Schaltfläche "In den Warenkorb".',
	"pp_js_faq" : 'Weitere Informationen finden Sie in den FAQ',
	"pp_js_postal_check" : 'Ich bezahle meine Bestellung per Scheck und lege das Papierfoto bei.',
	"pp_js_qte" : 'menge',
	"pp_js_postal_close" : 'Fenster schließen',
	"pp_js_erreur" : 'Verarbeitungsfehler',
	"pp_js_cgv" : 'Ich bestätige, dass das Bild nicht urheberrechtlich geschützt ist oder dass ich die Rechte daran besitze.',
	"pp_js_badq" : 'Die Bildqualität ist nicht gut genug',
	"pp_js_droits" : 'Sie müssen bestätigen, dass das Bild nicht urheberrechtlich geschützt ist oder dass Sie die Rechte daran besitzen.',
	"pp_js_nophoto" : 'Sie müssen ein Foto auswählen',
	"pp_js_cheq" : 'Sie müssen das Kästchen "Ich bezahle meine Bestellung per Scheck..." ankreuzen',
	"pp_js_format" : 'Sie müssen ein Format wählen',
	"pp_js_encours" : 'Aktueller Vorgang...',
	"pp_title" : 'Ihre Lieblingsfotos in einem personalisierten Puzzle!',
	"pp_titleformat" : 'Wählen Sie Ihr Format',
	"pp_titleddl" : 'Laden Sie Ihr Foto hoch',
	"pp_titlefinal" : 'Bringen Sie Ihr Puzzle zum Abschluss',
	"pp_mesimages" : 'MEINE BILDER',
	"pp_faq" : 'Häufig gestellte Fragen (Gebrauchsanweisung, Fristen...)',
	"pp_delai" : 'Fertigstellungszeit: 10 bis 15 Tage.',
	"pp_postal" : 'Ich möchte das Originalfoto per Post schicken',
	"pp_q" : 'Unzureichende Bildqualität. Vergrößern Sie Ihre Auswahl oder laden Sie ein größeres Bild hoch.',
	"pp_modepo" : 'Hochformat-Modus bereits aktiv!',
	"pp_modepa" : 'Querformat bereits aktiv!',
	"pp_dimensions" : 'Maße des zusammengesetzten Puzzles',
	"pp_environ" : ' ca.',
	"pp_nbp" : 'menge an Teilen',
	"pp_emballage" : 'Für ein noch gelungeneres Geschenk, ist das Foto Ihres Puzzles auf der Puzzle-Schachtel abgebildet: So verfügen Sie über eine Vorlage.',
	"pp_emballage_pack" : 'Bei diesem Angebot erhalten Sie Ihre personalisierten Puzzles in der Folienverpackung.',
	"left_plus" : 'Mehr ...',
	"left_plus_close" : 'Schließen - X',
	"left_plus_titre" : 'Unsere',
	"sendFriend_err1" : 'Bitte geben Sie den Namen Ihres Freundes ein',
	"sendFriend_err2" : 'Ihre E-Mail Adresse ist ungültig',
	"sendFriend_err3" : 'Sie müssen Ihren Namen und Ihre E-Mail Adresse eingeben',
	"mavertir_err1" : 'Ihre E-Mail Adresse ist ungültig',
	"mavertir_err2" : 'Sie müssen Ihre E-Mail Adresse eingeben',
	"libellecodepromo" : 'Tag -{0}% off',
	"setpromoday_update" : 'Es wird darauf hingewiesen! <br /> Sie erhalten -%2$s% auf Ihre Bestellung die %1$s. <br /> Sie müssen keinen Aktionscode eingeben, Ihre Bestellung wird automatisch rabattiert!',
	"setpromoday_err1" : 'Das eingegebene Datum scheint falsch zu sein',
	"setpromoday_err2" : 'Das eingegebene Datum scheint nicht korrekt zu sein',
	"setpromoday_err3" : 'Das Vorzugsangebot gilt leider nicht zur Weihnachtszeit.<br />Bitte wählen Sie ein neues Angebot aus.<br />',
	"setpromoday_err4" : 'Das Vorzugsangebot gilt leider nicht an Verkaufstagen. <br />Bitte wählen Sie ein neues Angebot aus.<br />',
	"prenomchild_err" : 'Wie lautet der Vorname Ihres Kindes?',
	"ddnchild_err" : 'Das eingegebene Geburtsdatum scheint falsch zu sein',
	"sexechild_err" : 'Ist es ein Mädchen, ein Junge?',
	"linkchild_err" : 'Wie sind Sie mit diesem Kind verwandt?',
	"status_enregistrement" : 'Ihre Bestellung wurde berücksichtigt.',
	"status_validation" : 'Ihre Zahlung wurde bestätigt.',
	"status_preparation" : 'Ihre Bestellung wird gerade vorbereitet.',
	"status_expedition" : 'Ihre Bestellung wurde versandt.',
	"status_livraison" : 'Ihre Bestellung wurde zugestellt.',
	"conditionGenerale" : {
		"1" : 'Allgemeine Verkaufsbedingungen',
		"2" : 'Nutzungsbedingungen',
		"3" : 'Datenschutzrichtlinie',
		"4" : 'Impressum',
		"5" : 'Geschäftsbedingungen Betriebsräte ',
		"6" : 'Allgemeine Geschäftsbedingungen Körperschaften',
		"7" : 'Wer sind wir?',
		"all" : 'Allgemeine Geschäftsbedingungen (Privatpersonen, Betriebsräte, Körperschaften)'
	},
	"pageStatique" : {
		"aide" : 'Online-Hilfe',
		"delivery" : 'Tarife und Lieferzeiten',
		"codesPromo" : 'Rabattcodes und Förderung',
		"newsletter" : 'Abonnieren Sie den Newsletter',
		"offres_entreprises" : 'Betriebsrat ',
		"offres_collectivites" : 'Körperschaft',
		"offres_collectivites_entreprises" : 'Betriebsräte und Körperschaften',
		"offresPromotionnelles" : 'Unsere Rückerstattungsangebote',
		"plan" : 'Sitemap',
		"presse" : 'Pressebereich',
		"recrutement" : 'Stellenmarkt',
		"recrutement_form" : 'Stellenmarkt',
		"retractation" : 'Widerrufen',
		"product_callback" : 'Produktrückrufe'
	},
	"dateName" : {
		"beforeYesterday" : 'vorgestern',
		"yesterday" : 'gestern',
		"today" : 'heute',
		"tomorrow" : 'morgen',
		"afterTomorrow" : 'übermorgen'
	},
	"openingHours" : 'von {0} bis {1} von {2} bis {3}',
	"sav" : {
		"selectOrder" : 'Wählen Sie die Ihrer Anfrage zugeordnete Bestellung aus',
		"orderNb" : 'Bestellnummer {0} - {1} ({2} €)'
	},
	"uplineSav" : {
		"businessDayBefore" : 'Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter <strong>%1$s</strong>.',
		"businessDayDuring" : '<strong>Haben Sie eine Frage?</strong> Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter<strong>%1$s</strong>.',
		"businessDayBeforeSpecialChristmas" : '<strong>Haben Sie eine Frage?</strong> Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter<strong>%1$s</strong>.',
		"businessDayDuringSpecialChristmas" : '<strong>Haben Sie eine Frage?</strong> Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter<strong>%1$s</strong>.',
		"businessDayDuringSaturdaySpecialChristmas" : '<strong>Haben Sie eine Frage?</strong> Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter<strong>%1$s</strong>.',
		"businessDayBeforeSpecialAfterChristmas" : '<strong>Haben Sie eine Frage?</strong> Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter<strong>%1$s</strong>.',
		"businessDayDuringSpecialAfterChristmas" : '<strong>Haben Sie eine Frage?</strong> Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter<strong>%1$s</strong>.',
		"nextBusinessDay" : '<strong>Haben Sie eine Frage?</strong> Sie erreichen uns heute von 9.00 bis 12.30 Uhr unter<strong>%1$s</strong>.',
		"tomorrow" : 'morgen',
		"afterTomorrow" : 'übermorgen'
	},
	"monthFr" : {
		"1" : 'Januar',
		"2" : 'Februar',
		"3" : 'März',
		"4" : 'April',
		"5" : 'Mai',
		"6" : 'Juni',
		"7" : 'Juli',
		"8" : 'August',
		"9" : 'September',
		"10" : 'Oktober',
		"11" : 'November',
		"12" : 'Dezember'
	},
	"uplineShipping" : {
		"today" : 'Heute gesendet',
		"otherDay" : 'Gesendet {0}',
		"dropshipping" : 'Lieferung innerhalb von 2 Wochen'
	},
	"listingHeaderDefaultTitreH1" : {
		"nouveautes" : 'Puzzle-Neuheiten',
		"promotions" : 'Puzzle-Förderung',
		"soldes" : 'Ermäßigte Puzzles',
		"topSale" : 'Die besten Puzzles',
		"destockage" : 'Puzzle-Lagerräumung'
	},
	"listingHeaderDefaultTitre" : {
		"nouveautes" : 'Puzzle-Neuheiten',
		"promotions" : 'Puzzle-Förderung',
		"soldes" : 'Ermäßigte Puzzles',
		"marques" : 'Alle Marken',
		"themes" : 'Alle Themen',
		"puzzlesByArtist" : 'Alle unsere Puzzles von Künstlern',
		"puzzlesByTheme" : 'Alle unsere Puzzles nach Themen',
		"topSale" : 'Meistverkaufte Puzzles',
		"destockage" : 'Puzzle-Lagerräumung',
		"odr" : ''
	},
	"listingHeaderDefaultDesc" : {
		"nouveautes" : 'Auf der Suche nach Ideen? Hier sind Sie genau richtig. Wählen Sie Ihr Geschenk einfach auf unserer Neuheiten-Seite aus. Hier finden Sie alle Neuheiten für Modellbauer. Wir bieten Ihnen eine große Auswahl an aktuellen Trends, damit Sie das ideale Puzzle finden. Egal, ob Sie Anfänger oder Profi-Puzzler sind, hier finden Sie das richtige Puzzle.',
		"promotions" : 'Wir haben Ihren Traum wahr werden lassen! Sie finden auf unserer Website eine große Auswahl an Produkten zu reduzierten Preisen. Günstige Puzzles und anderes Zubehör, was will man mehr? Da ist für jeden etwas dabei! Für Erwachsene und für Kinder finden Sie viele Artikel im Angebot. Greifen Sie zu, hier, auf Puzzle Boulevard, machen Sie die besten Schnäppchen! Erhalten Sie den besten Preis für Puzzles von Flugzeugen, Booten, Autos, Motorrädern, Militärfahrzeugen, Denkmälern, Lastwagen und Anhängern, Figuren, mit Weltraum-Motiven und für zahlreiche Zubehörteile. Sie alle warten nur darauf, Ihnen oder einem anderen Fan eine Freude zu machen.',
		"soldes" : 'Darauf haben Sie schon lange gewartet. Jetzt ist es so weit! Der Verkauf auf Puzzle Boulevard steht vor der Tür und wir möchten die kleinen Preise gerne an Sie weitergeben! Entdecken Sie jetzt unsere Auswahl an Puzzles und Zubehör, für alle Modellbauer und zu sehr günstigen Preisen.',
		"marques" : 'Finden Sie hunderte von Puzzle-Marken und andere Konstruktionsspiele auf unserer Website. Um alle zufriedenzustellen und viele Artikel vorschlagen zu können, hat unsere Website Rue Des Maquettes für Sie Marken ausgewählt, die viele Produkte anbieten. Die Marken sind nach Alphabet geordnet und leicht in der Liste auf unserer Seite wiederzufinden. Stöbern Sie in unserer Liste, um die für Sie passende Marke zu finden!',
		"topSale" : 'Finden Sie auf unserer Website unsere Bestseller-Liste! Diese kann sich als sehr hilfreich erweisen! Vor allem, wenn Sie nicht wissen, was Sie kaufen sollen. In dieser Bestseller-Liste sind die Artikel aufgeführt, die auf unserer Website am häufigsten gekauft werden. Sie spiegelt die aktuellen Trends wider und hilft Ihnen bei Ihrer Entscheidung, welches Produkt am besten zu Ihrer Suche passt. Jetzt steht dem perfekten Geschenk nichts mehr im Wege! Ob für Männer oder Frauen, Jungen oder Mädchen, die Bestseller-Liste bietet eine breite Auswahl an abwechslungsreichen Puzzles.',
		"destockage" : '',
		"odr" : ''
	},
	"defaultIntroduction" : {
		"categorie" : 'Finden Sie unser gesamtes Sortiment an {0} ! Diese Spiele- und Spielzeugwelt wird Ihre Kinder ganz sicher begeistern!',
		"attribut" : 'Tauchen Sie ein in die Spiele- und Spielzeugwelt {0}! Die Spielzeuge {0} werden alle Kinder, Groß und Klein, begeistern.'
	},
	"categorieChildrenSEO" : {
		"intro" : 'Entdecken Sie auch die Produkte von {0} : ',
		"item" : '<a href="{0}" title="{2}">{1}</a>, ',
		"last" : 'und <a href="{0}" title="{2}">{1}</a>.'
	},
	"facture_surplus_kdo" : 'Geschenkscheckgebühren',
	"codePromoDiscountAmount" : {
		"1" : '-{0}%',
		"2" : '-{0}€',
		"3" : '',
		"5" : '',
		"6" : '',
		"7" : '-{0}%',
		"8" : '',
		"9" : '',
		"10" : '-{0}%',
		"11" : '',
		"12" : '',
		"14" : '-{0}€'
	},
	"codePromoDiscountText" : {
		"1" : 'Sofortiger Rabatt',
		"2" : 'Sofortiger Rabatt',
		"3" : 'Kostenlose Lieferung',
		"5" : 'Produktzugabe',
		"6" : 'Aktionsangebot',
		"7" : '',
		"8" : '',
		"9" : 'Produktzugabe unter bestimmten Bedingungen',
		"10" : '',
		"11" : '',
		"12" : 'Produktzugabe mit Rabatt',
		"14" : 'zum 50€'
	},
	"__pluralRules" : {
		"comments" : 'http://cldr.unicode.org/index/downloads/cldr-24',
		"ar" : {
			"zero" : 'n==0',
			"one" : 'n==1',
			"two" : 'n==2',
			"few" : '(n % 100>=3 && n % 100<=10)',
			"many" : '(n % 100>=11 && n % 100<=99)'
		},
		"he" : {
			"one" : 'i==1 && v==0',
			"two" : 'i==2 && v==0',
			"many" : 'v==0 && (n>0 && n<10) && n % 10==0'
		},
		"iw" : {
			"one" : 'i==1 && v==0',
			"two" : 'i==2 && v==0',
			"many" : 'v==0 && (n>0 && n<10) && n % 10==0'
		},
		"af" : {
			"one" : 'n==1'
		},
		"asa" : {
			"one" : 'n==1'
		},
		"ast" : {
			"one" : 'n==1'
		},
		"az" : {
			"one" : 'n==1'
		},
		"bem" : {
			"one" : 'n==1'
		},
		"bez" : {
			"one" : 'n==1'
		},
		"bg" : {
			"one" : 'n==1'
		},
		"brx" : {
			"one" : 'n==1'
		},
		"cgg" : {
			"one" : 'n==1'
		},
		"chr" : {
			"one" : 'n==1'
		},
		"ckb" : {
			"one" : 'n==1'
		},
		"dv" : {
			"one" : 'n==1'
		},
		"ee" : {
			"one" : 'n==1'
		},
		"el" : {
			"one" : 'n==1'
		},
		"eo" : {
			"one" : 'n==1'
		},
		"es" : {
			"one" : 'n==1'
		},
		"eu" : {
			"one" : 'n==1'
		},
		"fo" : {
			"one" : 'n==1'
		},
		"fur" : {
			"one" : 'n==1'
		},
		"fy" : {
			"one" : 'n==1'
		},
		"gsw" : {
			"one" : 'n==1'
		},
		"ha" : {
			"one" : 'n==1'
		},
		"haw" : {
			"one" : 'n==1'
		},
		"hu" : {
			"one" : 'n==1'
		},
		"jgo" : {
			"one" : 'n==1'
		},
		"jmc" : {
			"one" : 'n==1'
		},
		"ka" : {
			"one" : 'n==1'
		},
		"kaj" : {
			"one" : 'n==1'
		},
		"kcg" : {
			"one" : 'n==1'
		},
		"kk" : {
			"one" : 'n==1'
		},
		"kkj" : {
			"one" : 'n==1'
		},
		"kl" : {
			"one" : 'n==1'
		},
		"ks" : {
			"one" : 'n==1'
		},
		"ksb" : {
			"one" : 'n==1'
		},
		"ku" : {
			"one" : 'n==1'
		},
		"ky" : {
			"one" : 'n==1'
		},
		"lb" : {
			"one" : 'n==1'
		},
		"lg" : {
			"one" : 'n==1'
		},
		"mas" : {
			"one" : 'n==1'
		},
		"mgo" : {
			"one" : 'n==1'
		},
		"ml" : {
			"one" : 'n==1'
		},
		"mn" : {
			"one" : 'n==1'
		},
		"nah" : {
			"one" : 'n==1'
		},
		"nb" : {
			"one" : 'n==1'
		},
		"nd" : {
			"one" : 'n==1'
		},
		"ne" : {
			"one" : 'n==1'
		},
		"nn" : {
			"one" : 'n==1'
		},
		"nnh" : {
			"one" : 'n==1'
		},
		"no" : {
			"one" : 'n==1'
		},
		"nr" : {
			"one" : 'n==1'
		},
		"ny" : {
			"one" : 'n==1'
		},
		"nyn" : {
			"one" : 'n==1'
		},
		"om" : {
			"one" : 'n==1'
		},
		"or" : {
			"one" : 'n==1'
		},
		"os" : {
			"one" : 'n==1'
		},
		"pap" : {
			"one" : 'n==1'
		},
		"ps" : {
			"one" : 'n==1'
		},
		"rm" : {
			"one" : 'n==1'
		},
		"rof" : {
			"one" : 'n==1'
		},
		"rwk" : {
			"one" : 'n==1'
		},
		"saq" : {
			"one" : 'n==1'
		},
		"seh" : {
			"one" : 'n==1'
		},
		"sn" : {
			"one" : 'n==1'
		},
		"so" : {
			"one" : 'n==1'
		},
		"sq" : {
			"one" : 'n==1'
		},
		"ss" : {
			"one" : 'n==1'
		},
		"ssy" : {
			"one" : 'n==1'
		},
		"st" : {
			"one" : 'n==1'
		},
		"syr" : {
			"one" : 'n==1'
		},
		"ta" : {
			"one" : 'n==1'
		},
		"te" : {
			"one" : 'n==1'
		},
		"teo" : {
			"one" : 'n==1'
		},
		"tig" : {
			"one" : 'n==1'
		},
		"tk" : {
			"one" : 'n==1'
		},
		"tn" : {
			"one" : 'n==1'
		},
		"tr" : {
			"one" : 'n==1'
		},
		"ts" : {
			"one" : 'n==1'
		},
		"uz" : {
			"one" : 'n==1'
		},
		"ve" : {
			"one" : 'n==1'
		},
		"vo" : {
			"one" : 'n==1'
		},
		"vun" : {
			"one" : 'n==1'
		},
		"wae" : {
			"one" : 'n==1'
		},
		"xh" : {
			"one" : 'n==1'
		},
		"xog" : {
			"one" : 'n==1'
		},
		"ak" : {
			"one" : '(n>=0 && n<=1)'
		},
		"bh" : {
			"one" : '(n>=0 && n<=1)'
		},
		"guw" : {
			"one" : '(n>=0 && n<=1)'
		},
		"ln" : {
			"one" : '(n>=0 && n<=1)'
		},
		"mg" : {
			"one" : '(n>=0 && n<=1)'
		},
		"nso" : {
			"one" : '(n>=0 && n<=1)'
		},
		"pa" : {
			"one" : '(n>=0 && n<=1)'
		},
		"ti" : {
			"one" : '(n>=0 && n<=1)'
		},
		"wa" : {
			"one" : '(n>=0 && n<=1)'
		},
		"ff" : {
			"one" : '(i==0 || i==1)'
		},
		"fr" : {
			"one" : '(i==0 || i==1)'
		},
		"hy" : {
			"one" : '(i==0 || i==1)'
		},
		"kab" : {
			"one" : '(i==0 || i==1)'
		},
		"lv" : {
			"zero" : 'n % 10==0 || (n % 100>=11 && n % 100<=19) || v==2 && (f % 100>=11 && f % 100<=19)',
			"one" : 'n % 10==1 && n % 100 != 11 || v==2 && f % 10==1 && f % 100 != 11 || v != 2 && f % 10==1'
		},
		"iu" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"kw" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"naq" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"se" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"sma" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"smi" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"smj" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"smn" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"sms" : {
			"one" : 'n==1',
			"two" : 'n==2'
		},
		"ga" : {
			"one" : 'n==1',
			"two" : 'n==2',
			"few" : '(n>=3 && n<=6)',
			"many" : '(n>=7 && n<=10)'
		},
		"mo" : {
			"one" : 'i==1 && v==0',
			"few" : 'v != 0 || n==0 || n != 1 && (n % 100>=1 && n % 100<=19)'
		},
		"ro" : {
			"one" : 'i==1 && v==0',
			"few" : 'v != 0 || n==0 || n != 1 && (n % 100>=1 && n % 100<=19)'
		},
		"lt" : {
			"one" : 'n % 10==1 && (n % 100>11 && n % 100<19)',
			"few" : '(n % 10>=2 && n % 10<=9) && (n % 100>11 && n % 100<19)',
			"many" : 'f != 0'
		},
		"be" : {
			"one" : 'n % 10==1 && n % 100 != 11',
			"few" : '(n % 10>=2 && n % 10<=4) && (n % 100>12 && n % 100<14)',
			"many" : 'n % 10==0 || (n % 10>=5 && n % 10<=9) || (n % 100>=11 && n % 100<=14)'
		},
		"cs" : {
			"one" : 'i==1 && v==0',
			"few" : '(i>=2 && i<=4) && v==0',
			"many" : 'v != 0'
		},
		"sk" : {
			"one" : 'i==1 && v==0',
			"few" : '(i>=2 && i<=4) && v==0',
			"many" : 'v != 0'
		},
		"pl" : {
			"one" : 'i==1 && v==0',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14)',
			"many" : 'v==0 && i != 1 && (i % 10>=0 && i % 10<=1) || v==0 && (i % 10>=5 && i % 10<=9) || v==0 && (i % 100>=12 && i % 100<=14)'
		},
		"sl" : {
			"one" : 'v==0 && i % 100==1',
			"two" : 'v==0 && i % 100==2',
			"few" : 'v==0 && (i % 100>=3 && i % 100<=4) || v != 0'
		},
		"mt" : {
			"one" : 'n==1',
			"few" : 'n==0 || (n % 100>=2 && n % 100<=10)',
			"many" : '(n % 100>=11 && n % 100<=19)'
		},
		"mk" : {
			"one" : 'v==0 && i % 10==1 || f % 10==1'
		},
		"cy" : {
			"zero" : 'n==0',
			"one" : 'n==1',
			"two" : 'n==2',
			"few" : 'n==3',
			"many" : 'n==6'
		},
		"lag" : {
			"zero" : 'n==0',
			"one" : '(i==0 || i==1) && n != 0'
		},
		"shi" : {
			"one" : 'i==0 || n==1',
			"few" : '(n>=2 && n<=10)'
		},
		"br" : {
			"one" : 'n % 10==1 && n % 100 != 11 && n % 100 != 71 && n % 100 != 91',
			"two" : 'n % 10==2 && n % 100 != 12 && n % 100 != 72 && n % 100 != 92',
			"few" : '(n % 10>=3 && n % 10<=4),9 && ((n % 100>10 && n % 100<19) || (n % 100>70 && n % 100<79) || (n % 100>90 && n % 100<99))',
			"many" : 'n != 0 && n % 1000000==0'
		},
		"ksh" : {
			"zero" : 'n==0',
			"one" : 'n==1'
		},
		"tzm" : {
			"one" : '(n>=0 && n<=1) || (n>=11 && n<=99)'
		},
		"gv" : {
			"one" : 'n % 10==1',
			"two" : 'n % 10==2',
			"few" : '(n % 100==0 || n % 100==20 || n % 100== 40 || n % 100== 60)'
		},
		"gd" : {
			"one" : '(n==1 || n==11)',
			"two" : '(n==2 || n==12)',
			"few" : '(n>=3 && n<=10) || (n>=13 && n<=19)'
		},
		"fil" : {
			"one" : '(i>=0 && i<=1) && v==0'
		},
		"tl" : {
			"one" : '(i>=0 && i<=1) && v==0'
		},
		"ca" : {
			"one" : 'i==1 && v==0'
		},
		"de" : {
			"one" : 'i==1 && v==0'
		},
		"en" : {
			"one" : 'i==1 && v==0'
		},
		"et" : {
			"one" : 'i==1 && v==0'
		},
		"fi" : {
			"one" : 'i==1 && v==0'
		},
		"gl" : {
			"one" : 'i==1 && v==0'
		},
		"it" : {
			"one" : 'i==1 && v==0'
		},
		"ji" : {
			"one" : 'i==1 && v==0'
		},
		"nl" : {
			"one" : 'i==1 && v==0'
		},
		"sv" : {
			"one" : 'i==1 && v==0'
		},
		"sw" : {
			"one" : 'i==1 && v==0'
		},
		"ur" : {
			"one" : 'i==1 && v==0'
		},
		"yi" : {
			"one" : 'i==1 && v==0'
		},
		"pt" : {
			"one" : 'i==1 && v==0 || i==0 && t==1'
		},
		"da" : {
			"one" : 'n==1 || t != 0 && (i==0 || i==1)'
		},
		"pt_PT" : {
			"one" : 'n==1 && v==0'
		},
		"am" : {
			"one" : 'i==0 || n==1'
		},
		"bn" : {
			"one" : 'i==0 || n==1'
		},
		"fa" : {
			"one" : 'i==0 || n==1'
		},
		"gu" : {
			"one" : 'i==0 || n==1'
		},
		"hi" : {
			"one" : 'i==0 || n==1'
		},
		"kn" : {
			"one" : 'i==0 || n==1'
		},
		"mr" : {
			"one" : 'i==0 || n==1'
		},
		"zu" : {
			"one" : 'i==0 || n==1'
		},
		"is" : {
			"one" : 't==0 && i % 10==1 && i % 100 != 11 || t != 0'
		},
		"si" : {
			"one" : '(n==0 || n==1) || i==0 && f==1'
		},
		"bs" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"hr" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"sh" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"sr" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11 || f % 10==1 && f % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14) || (f % 10>=2 && f % 10<=4) && (f % 100>12 && f % 100<14)'
		},
		"ru" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11',
			"many" : 'v==0 && i % 10==0 || v==0 && (i % 10>=5 && i % 10<=9) || v==0 && (i % 100>=11 && i % 100<=14)'
		},
		"uk" : {
			"one" : 'v==0 && i % 10==1 && i % 100 != 11',
			"few" : 'v==0 && (i % 10>=2 && i % 10<=4) && (i % 100>12 && i % 100<14)',
			"many" : 'v==0 && i % 10==0 || v==0 && (i % 10>=5 && i % 10<=9) || v==0 && (i % 100>=11 && i % 100<=14)'
		}
	}
};
